import { render } from "./AppSkeletonDialog.vue?vue&type=template&id=17b1e99a&scoped=true&ts=true"
import script from "./AppSkeletonDialog.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonDialog.vue?vue&type=script&lang=ts"

import "./AppSkeletonDialog.vue?vue&type=style&index=0&id=17b1e99a&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b1e99a"]])

export default __exports__